/** Whether a tool call succeeded, from its persisted output payload. */

export type ToolOutcome = "success" | "error" | "unknown";

export function toolOutcomeFromOutput(output?: Record<string, unknown>): ToolOutcome {
  if (!output || Object.keys(output).length === 0) return "unknown";
  const status = String(output.status ?? "").toLowerCase();
  if (status === "ok" || status === "success") return "success";
  if (status === "error" || status === "failed" || output.error != null) return "error";
  return "unknown";
}

/** Map tool name → best-known outcome across orchestration steps (last call wins). */
export function toolOutcomesByName(
  steps: { tool: string; output?: Record<string, unknown> }[],
): Map<string, ToolOutcome> {
  const map = new Map<string, ToolOutcome>();
  for (const step of steps) {
    if (!step.tool) continue;
    map.set(step.tool, toolOutcomeFromOutput(step.output));
  }
  return map;
}

export function toolsUsed(steps: { tool: string }[]): Set<string> {
  return new Set(steps.map((s) => s.tool).filter(Boolean));
}
